import { reset, rem } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../helpers';
import { theme as ItemTheme } from './item/item.styles';

export const tag = tagName('list');

export const styles = [
  reset.button,
  css`
    :where(ul) {
      block-size: 100%;
      display: flex;
      flex-direction: column;
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

    :where(ul[direction='row']) {
      flex-direction: row;

      ::slotted(a-list-item) {
        flex: 1;
        ${ItemTheme.propertyName('border-block-end-width')}: ${rem(0)};
        ${ItemTheme.propertyName('border-inline-end-width')}: ${rem(1)};
      }
    }
  `,
];
